module.exports = __webpack_public_path__ + "static/media/56_logo_eng.05b31b98.png";